import type {
  CreatePrintDocumentData,
  PrintDocumentCreationRequest,
  UpdatePrintDocumentFileUploadStatusData,
  UpdatePrintDocumentFileUploadStatusParams,
} from '~/api-spec/__generated__/main'
import { httpClient, type RequestMeta } from '~/http/client'
import type { WithNullableOptionals } from '~/http/request'

import { adaptPrintDocument, adaptPrintDocumentCreation } from './adapters'
import type { PrintDocument, PrintDocumentCreation } from './schemas'

// 서버는 요청의 선택 필드(headtitle·subtitle, 표지 데이터의 subtitle·academyName 등)를 String?·ObjectNode? 로
// 받지만 스펙이 nullable 을 빠뜨려 optional 로만 그린다. 선택 필드에 null 을 되살린다.
// 2026-09-30 백엔드 develop 의 printDocument/controller/request/PrintDocumentCreationRequest.kt·
// workbook/model/dto/CoverData.kt 로 확인.
export type PrintDocumentCreationPayload = WithNullableOptionals<
  Omit<PrintDocumentCreationRequest, 'coverData'>
> & {
  coverData: WithNullableOptionals<PrintDocumentCreationRequest['coverData']>
}
export type PrintDocumentFileUploadStatusUpdate = UpdatePrintDocumentFileUploadStatusParams

// 인쇄물 API 는 CommonResponse 봉투 없이 본문을 그대로 준다.
export const createPrintDocument = async (
  payload: PrintDocumentCreationPayload,
  meta?: RequestMeta,
): Promise<PrintDocumentCreation> => {
  const body = await httpClient().post<CreatePrintDocumentData>('/print-document', payload, {
    meta,
  })
  return adaptPrintDocumentCreation(body)
}

export const updatePrintDocumentFileUploadStatus = async (
  { printDocumentId, fileUploadStatus }: PrintDocumentFileUploadStatusUpdate,
  meta?: RequestMeta,
): Promise<PrintDocument> => {
  const body = await httpClient().put<UpdatePrintDocumentFileUploadStatusData>(
    `/print-document/${printDocumentId}/file-upload-status/${fileUploadStatus}`,
    undefined,
    { meta },
  )
  return adaptPrintDocument(body)
}
